
/* Header menu
**********************************************************************/

jQuery(document).ready(function($) {
	
	var $menu = $('.header-menu');
	var active = false;
	var changing = false;

	var show = function() {
		active = true;
		change();
	}
	
	var hide = function() {
		active = false;
		change();
	}
	
	var change = function() {
		changing = true;
		setTimeout(function() {
			$menu.css('display', active ? 'flex' : 'none');
			changing = false;
		}, 200);
	}
		
	$('.header-elements .menu')
		.on('mouseenter', show)
		.on('mouseleave', hide)
		.on('click', function() {
			if (!changing)
				active ? hide() : show();
		});
		
	$menu
		.on('mouseenter', show)
		.on('mouseleave', hide);
		
	// Search
	
	$('#search-form .overlay').on('click', function() {
		$('#search-form').removeClass('open');
	});
	
	$('.header-elements .search').on('click', function() {
		$('#search-form').addClass('open');
	});

});
	